import autoUser from '../../apis/auto.user';
import * as types from '../mutation-types';
let getLoginedPromise = null;
let userInfoPromise = null;
export default {
  state: {
    loginInfo: {
      logined: false,
      user: {
        userId: 0,
        realName: '',
        nickName: '',
        phone: ''
      }
    }
  },
  mutations: {
    [types.SET_USER_ID] (state, { userId }) {
      state.loginInfo.logined = true;
      state.loginInfo.user.userId = userId;
    },
    [types.SET_USER_INFO] (state, { realName, nickName, phone }) {
      state.loginInfo.user.realName = realName;
      state.loginInfo.user.nickName = nickName;
      state.loginInfo.user.phone = phone;
    }
  },
  getters: {
    loginInfo: state => state.loginInfo
  },
  actions: {
    getAutoLoginedUserId ({ state, commit }) {
      if (state.loginInfo.logined) {
        return Promise.resolve();
      }
      if (!getLoginedPromise) {
        getLoginedPromise = autoUser.getAutoLoginedUserId().then(function (data) {
          commit(types.SET_USER_ID, { userId: data.userId });
        });
      }
      return getLoginedPromise;
    },
    getUserInfo ({ dispatch, commit }) {
      if (!userInfoPromise) {
        userInfoPromise = dispatch('getAutoLoginedUserId').then(function () {
          return autoUser.getUserInfo();
        }).then(({ realName, nickName, phone }) => {
          commit(types.SET_USER_INFO, { realName, nickName, phone });
        });
      }
      return userInfoPromise;
    }
  },
  namespaced: true
};
